module.exports = __webpack_public_path__ + "media/images/emblems/Kriens_LU-3915d3ef42b4080374296da78c71158d.png";